import React from 'react';
import { Chip, Box, Typography } from '@mui/material';
import {
  SupervisorAccount as SuperAdminIcon,
  AdminPanelSettings as AdminIcon,
  ManageAccounts as ManagerIcon,
  Person as UserIcon,
  Visibility as ViewerIcon,
} from '@mui/icons-material';
import { useRoleContext } from '../contexts/RoleContext';

function RoleIndicator() {
  const { userRole, user, loading } = useRoleContext();

  if (loading) return null;

  const getRoleConfig = (role) => {
    switch (role) {
      case 'super_admin':
        return {
          label: 'Super Admin',
          color: 'error',
          icon: <SuperAdminIcon sx={{ fontSize: 16 }} />,
        };
      case 'admin':
        return {
          label: 'Admin',
          color: 'warning',
          icon: <AdminIcon sx={{ fontSize: 16 }} />,
        };
      case 'manager':
        return {
          label: 'Manager',
          color: 'info',
          icon: <ManagerIcon sx={{ fontSize: 16 }} />,
        };
      case 'user':
        return {
          label: 'User',
          color: 'success',
          icon: <UserIcon sx={{ fontSize: 16 }} />,
        };
      case 'viewer':
        return {
          label: 'Viewer',
          color: 'default',
          icon: <ViewerIcon sx={{ fontSize: 16 }} />,
        };
      default:
        return {
          label: 'Unknown',
          color: 'default',
          icon: <UserIcon sx={{ fontSize: 16 }} />,
        };
    }
  };

  const roleConfig = getRoleConfig(userRole);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Chip
        icon={roleConfig.icon}
        label={roleConfig.label}
        color={roleConfig.color}
        size="small"
        variant="outlined"
        sx={{ fontWeight: 500 }}
      />
      {user?.name && (
        <Typography variant="caption" color="text.secondary">
          {user.name}
        </Typography>
      )}
    </Box>
  );
}

export default RoleIndicator;
